require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Portal/PortalManager.tsx";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var PortalManager = function (_React$PureComponent) {
  (0, _inherits2["default"])(PortalManager, _React$PureComponent);

  function PortalManager() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, PortalManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(PortalManager)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      portals: []
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mount", function (key, children) {
      _this.setState(function (state) {
        return {
          portals: [].concat((0, _toConsumableArray2["default"])(state.portals), [{
            key: key,
            children: children
          }])
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "update", function (key, children) {
      return _this.setState(function (state) {
        return {
          portals: state.portals.map(function (item) {
            if (item.key === key) {
              return _objectSpread({}, item, {
                children: children
              });
            }

            return item;
          })
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "unmount", function (key) {
      return _this.setState(function (state) {
        return {
          portals: state.portals.filter(function (item) {
            return item.key !== key;
          })
        };
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(PortalManager, [{
    key: "render",
    value: function render() {
      return this.state.portals.map(function (_ref) {
        var key = _ref.key,
            children = _ref.children;
        return React.createElement(_reactNative.View, {
          key: key,
          collapsable: false,
          pointerEvents: "box-none",
          style: _reactNative.StyleSheet.absoluteFill,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        }, children);
      });
    }
  }]);
  return PortalManager;
}(React.PureComponent);

exports["default"] = PortalManager;